module.exports = __webpack_public_path__ + "img/logo_login.faab22e7.png";